import { StatusProps } from "@components/index";

const statusMap: Record<Sentinel.Enumerators.ProcessExecutionStatus, StatusProps["variant"]> = {
  NOT_STARTED: "neutral",
  STARTED_EARLY: "info",
  STARTED: "info",
  STARTED_LATE: "info",
  DELAYED: "info",
  AWAITING_END: "info",
  COMPLETED_EARLY: "positive",
  COMPLETED: "positive",
  COMPLETED_LATE: "positive",
  COMPLETED_LATE_AWAIT_JUSTIFICATION: "awaiting-justification",
  COMPLETED_LATE_AWAIT_FINALIZE_JUSTIFICATION: "awaiting-justification",
  ERROR: "negative",
  CANCELED: undefined,
  NON_EXECUTION: "warning",
};

export function useCardVariant(status?: Sentinel.Enumerators.ProcessExecutionStatus): StatusProps["variant"] {
  return statusMap[status];
}
